import React from 'react';
import {
  Button, Select, Divider, Descriptions,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useSimpleCondition from './useSimpleCondition';

import styles from './SimpleCondition.module.less';

const { Option } = Select;

function SimpleCondition(props) {

  const { t } = useTranslation();
  const { isLastItem, ...rest } = props;
  const {
    orCondition,
    removeOrCondition,
    onChangeOrCondition,
    isEditDefault,
    valueType,
    optionDescription,
  } = useSimpleCondition({ ...rest });
  const {
    type,
  } = orCondition;

  return (
    <>
      <div className={styles.wrapper}>
        <Button
          className={styles.remove_item}
          shape="circle"
          size="small"
          type="text"
          onClick={removeOrCondition}
          disabled={isEditDefault}
        >
          <FontAwesomeIcon icon={faMinusCircle} />
        </Button>

        <div className={styles.inputs}>
          <Select
            className={`${styles.take_two_columns}`}
            value={type}
            onSelect={(value) => onChangeOrCondition('type', value)}
            disabled={isEditDefault}
          >
            { valueType.map((data) => {

              const key = `select_${data.value}`;
              return (
                <Option key={key} value={data.value}>
                  {data.name}
                </Option>

              );

            })}
          </Select>

          { valueType.map((data) => {

            if (data.value === type) {

              return (
                <div className={styles.take_three_columns} key={`log_level_${data.value}`}>
                  <Descriptions className={styles.descriptions}>
                    <Descriptions.Item className={styles.descriptionsItem} label={t('tables.logs.columns.level')}>{data.label}</Descriptions.Item>
                  </Descriptions>
                </div>
              );

            }
            return null;

          })}

          { valueType.map((data) => {

            if (data.value === type) {

              return (
                <div className={styles.take_four_columns} key={`description_${data.value}`}>
                  <Descriptions className={styles.descriptions}>
                    <Descriptions.Item label={t('box.notificationInverter.table.description')}>{optionDescription[type]}</Descriptions.Item>
                  </Descriptions>
                </div>
              );

            }
            return null;

          })}

        </div>
      </div>
      {!isLastItem && <Divider className={styles.divider} />}
    </>
  );

}

SimpleCondition.propTypes = {
  groupIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isLastItem: PropTypes.bool,
};

SimpleCondition.defaultProps = {
  isLastItem: false,
};

export default SimpleCondition;
